
export class Comorbidities   {
  
  id?: number;  
  name: string;
  nameKey: string;
  isDefault?: boolean;
  nameLc?: string;
}
